<script>
export default {
  name: "s-layout",

  inject: ["hdl"],

  props: {
    /**
     * Definir como `true` quando for usado como raíz de uma
     * janela yanda (janela com código)
     */
    yanda: {
      type: Boolean,
      default: false,
    },
    /**
     * - `default`: conteúdo do slot padrão é estilizado e contido numa
     * `div` com id `#body`.
     *   - `<div id="body"> ...slot </div>`
     * - `custom`: conteúdo do slot padrão é filho direto da root e não é
     * estilizado.
     * - `tabs`: conteúdo do slot padrão usa o modelo necessário para utilizar
     * as tabs do jQuery.
     *   - `<div id="body"><div id="tabs"> ...slot </div></div>`
     */
    build: {
      type: String,
      default: "default",
      validator: (value) => ["default", "custom", "tabs"].includes(value),
    },
  },

  mounted() {
    if (this.build === "tabs") {
      jQuery(this.hdl.$("tabs")).tabs();
    }
  },
};
</script>

<template>
  <div class="s-layout" :class="{yanda}">
    <slot name="extra" />
    <template v-if="build === 'custom'">
      <slot />
    </template>
    <div id="body" v-else class="s-layout__body">
      <div id="tabs" v-if="build === 'tabs'">
        <slot />
      </div>
      <slot v-else />
    </div>
    <footer id="footer" v-if="$slots.footer" class="s-layout__footer">
      <slot name="footer" />
    </footer>
  </div>
</template>

<style>
#body:has(.s-layout.yanda) {
  display: flex;

  >.ajan-min-width {
    width: 100%;
    display: flex;
  }
}
</style>
<style scoped>
.s-layout {
  flex: 1;
  flex-direction: column;
}

.s-layout__body {
  flex: 1 1 0;
  margin: 6px 0;
  overflow: auto;
  flex-direction: column;
}

.s-layout__body:has(#tabs) {
  margin-top: 0;
}

.s-layout__body>#tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.s-layout__body>#tabs>[id^="tabs-"] {
  flex: 1;
}

.s-layout__body>.s-card {
  flex: 1;
  margin: 2px 1px;
}

.s-layout__footer {
  gap: 5px;
  padding: 5px;
  margin-top: auto;
  text-align: right;
  justify-content: flex-end;
  border-top: solid 1px #aaa;
}

.s-layout,
.s-layout__body,
.s-layout__footer {
  display: flex;
  box-sizing: border-box;
}
</style>